
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getOnecontenidoarticulos2dkws } from '../../api/contenidoarticulos2dkws.api'

import './articuloskhj53.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Particuloskhj53 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_67698ae29ccea34376cf88ff, setLoftyEndpoint_67698ae29ccea34376cf88ff] = useState({});
	
useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_67698ae29ccea34376cf88ff = await getOnecontenidoarticulos2dkws({ _id: match.params.id, token: loftytoken || 'asdsa' });
			setLoftyEndpoint_67698ae29ccea34376cf88ff(loftyres_67698ae29ccea34376cf88ff.data);
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id676ad5e01de4874021c216f5" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="inftum"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu70g5.png"
        alt="undefined"
      />
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/servicios"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>SERVICIOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/blog"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>ARTICULOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contactanos"
        type="button"
      >
        
    <div id="isq53" className="">
    <>CONTÁCTANOS</>
    </div>
    
      </a>
      
      </div>
      
      <div id="ibbry6" className="">
      
      </div>
      
      <div id="iacot" className="">
      
      <span className="material-icons " id="indcti">
        
      <span className="material-icons " id="izk84l">
        
      </span>
      
      </span>
      
        <a
          target="_blank"
          className=""
          id="isdo4d"
          href=""
        >
          
      <span className="material-icons " id="i3c93a">
        <>call</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="igbhjj"
          href=""
        >
          
      <span className="material-icons " id="iu387l">
        <>mail</>
      </span>
      
        </a>
        
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>INICIO</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <>SERVICIOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/articulos"
        type=""
      >
        <>ARTICULOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>CONTÁCTANOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div
        id="ir55ho"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iuu8ch">
        <>Guía Completa para Incorporar el Wellness en tu Vida Diaria</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="i0tfl" className="">
      
        <div id="i90fy5" className="">
        
        </div>
        
      <div
        id="iz494b"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="2000"
      >
      
      <div id="i1xrzo" className="">
      
      <div className="" id="ift5ld">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iusi42">
        <>¡Comienza Hoy!</>
      </span>
      
      </div>
      
      <div className="" id="iposa8">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="impwp2">
        <>Incorporar wellness a tu vida no requiere cambios drásticos. Empieza con pequeños pasos, como dedicar 10 minutos al día a la meditación o preparar una comida saludable. Con el tiempo, estos hábitos se convertirán en parte de tu estilo de vida.</>
      <br className="" id="" />
      <>Recuerda, el bienestar no es un destino, es un viaje continuo. ¡Tu versión más saludable y feliz te está esperando!</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="iom3li"
          href="#"
        >
          
    <div id="iqb9c" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i1qykw">
        <>VER MAS CONTENIDO COMO ESTE</>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="iwdze7" className="">
      
      <div id="ia2meh" className="">
      
      <div className="" id="iiew7j">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i1nsox">
        <>Talvez también te interese</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9f89n">
        <>Choloma, Cortes</>
      <br className="" id="" />
      <>Res. Bello Horizonte, Segunda etapa</>
      </span>
      
      </div>
      
      <div id="i3kbn4" className="">
      
        <a
          target="_blank"
          className=""
          id="ixsthl"
          href="#"
        >
          
      <img
        className=""
        id="iwpiyw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jbbv.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ikcig4"
          href="#"
        >
          
      <img
        className=""
        id="iv6mle"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jd5s.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="itq03p"
          href="#"
        >
          
      <img
        className=""
        id="isa627"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jfas.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ig3kxb"
          href="#"
        >
          
      <img
        className=""
        id="iqlafz"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jgsb.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="iz2wsy"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu722a.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div id="i2vw8i" className="">
      
      </div>
      
      <div id="iabdji" className="">
      
      <div id="izci0t" className="">
      
      <div className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iubk6b">
        <>Copyrigt © 2024 </>
      </span>
      
      </div>
      
      <div className="" id="i4zwph">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix41ho">
        <>Terapias Energéticas</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ip8opa" className="">
      
      <div className="" id="in8zl9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iytx9d">
        <>Términos y condiciones</>
      </span>
      
      </div>
      
      <div className="" id="ivyeul">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5zx35">
        <>Políticas de privacidad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Particuloskhj53);
  